import React, { useState } from 'react';
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline';
import CRUDManager from '../../../shared/components/crud/CRUDManager';
import { childRecordConfig } from '../config/childrenRecordConfig';
import ImportChildrenModal from '../components/ImportChildrenModal';

export default function ChildRecordsPage() {
  const [showImportModal, setShowImportModal] = useState(false);

  return (
    <div>
      {/* Import button row */}
      <div className="flex justify-end px-4 lg:px-6 pt-4 lg:pt-6">
        <button
          onClick={() => setShowImportModal(true)}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 active:bg-green-800 rounded-lg shadow-sm transition-colors"
        >
          <ArrowUpTrayIcon className="w-4 h-4" />
          Import Children (Excel)
        </button>
      </div>

      <CRUDManager config={childRecordConfig} />

      <ImportChildrenModal
        isOpen={showImportModal}
        onClose={() => setShowImportModal(false)}
        onImportSuccess={() => {
          setShowImportModal(false);
          window.location.reload();
        }}
      />
    </div>
  );
}